import { IAddress } from '@/types'
import { create } from 'zustand'

interface State {
  tempAddress: Partial<IAddress> | null
  setTempAddress: (address: Partial<IAddress> | null) => void
}

/**
 * Used mainly for buy flow, as the user needs to confirm address update after completing the order and being redirected to the "Thanks" page.
 */
export const useTempAddress = create<State>(set => ({
  tempAddress: null,
  setTempAddress: address => {
    set(() => ({ tempAddress: address }))
  },
}))
